import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  heroDescription: string
  heroImage: {
    data: {
      attributes: StrapiImageFile
    }
  }
  heroTitleImage: {
    data: {
      attributes: StrapiImageFile
    }
  }
  heroSubtext: string
  primaryCta: StrapiLinkSharedComponent | null
  secondaryCta: StrapiLinkSharedComponent | null
}

function HeroSection({
  heroDescription,
  heroImage,
  heroTitleImage,
  heroSubtext,
  primaryCta,
  secondaryCta
}: Props): JSX.Element {
  return (
    <section className="container | grid grid-cols-1 md:grid-cols-2 gap-x-6 lg:gap-x-12 | py-14 lg:py-24">
      <div>
        {heroTitleImage.data ? (
          <Image
            src={heroTitleImage.data.attributes.url}
            height={heroTitleImage.data.attributes.height}
            width={heroTitleImage.data.attributes.width}
            className="max-w-md w-full | mb-6 mx-auto md:mx-0"
            alt={heroTitleImage.data.attributes.alternativeText ?? ''}
            priority
          />
        ) : null}

        <Image
          src={heroImage.data.attributes.url}
          height={heroImage.data.attributes.height}
          width={heroImage.data.attributes.width}
          className="md:hidden | max-w-md w-full | mb-12 mx-auto"
          alt={heroImage.data.attributes.alternativeText ?? ''}
          priority
        />

        <div
          className="text-base lg:text-xl | mb-4"
          dangerouslySetInnerHTML={{ __html: heroDescription }}
        />

        <div
          className="text-base lg:text-xl | mb-10 md:mb-12"
          dangerouslySetInnerHTML={{ __html: heroSubtext }}
        />

        <div className="flex flex-col lg:flex-row gap-5">
          {primaryCta ? (
            <Link
              href={primaryCta.href}
              className="text-lg md:text-xl text-blue-50 font-medium text-center | w-full lg:max-w-col-3 | new-pill-btn-tertiary"
            >
              {primaryCta.title}
            </Link>
          ) : null}
          {secondaryCta ? (
            <Link
              href={secondaryCta.href}
              className="text-lg md:text-xl bg-white text-blue-50 font-medium text-center | inline-flex items-center justify-center | max-h-14 py-3 px-6 w-full lg:max-w-col-3 | rounded-full"
            >
              {secondaryCta.title}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="hidden md:block | justify-self-center lg:justify-self-end">
        <Image
          src={heroImage.data.attributes.url}
          height={heroImage.data.attributes.height}
          width={heroImage.data.attributes.width}
          className="max-w-lg w-full"
          alt={heroImage.data.attributes.alternativeText ?? ''}
          priority
        />
      </div>
    </section>
  )
}

export default HeroSection
